import { EVM_CHAIN_IDS } from './constants';

export const isEVMNetwork = (network) => Object.keys(EVM_CHAIN_IDS).includes(network);
